import { useMemo } from "react";
import { useIntegrations } from "../contexts";

const USAGE_INTEGRATION_IDS = [
  "amplitude",
  "posthog",
  "mixpanel",
  "segment",
  "pendo",
  "generic",
];

export const useUsageStatus = ({ hasData, error, metricsLoading }) => {
  const { integrations, loading: integrationsLoading } = useIntegrations();

  const usageIntegration = useMemo(
    () =>
      integrations.find((i) =>
        USAGE_INTEGRATION_IDS.includes(i.integration_id),
      ),
    [integrations],
  );

  const loading = integrationsLoading || metricsLoading;

  const status = useMemo(() => {
    if (loading) return null;
    if (!usageIntegration) return "no_integration";
    if (usageIntegration.status === "PENDING_SETUP") return "pending_setup";
    if (error) return "error";
    if (hasData) return "has_data";
    return "no_data";
  }, [loading, usageIntegration, error, hasData]);

  return { status, loading, usageIntegration };
};
